import { render, staticRenderFns } from "./MyAccountScreen.vue?vue&type=template&id=129d403d&"
import script from "./MyAccountScreen.vue?vue&type=script&lang=js&"
export * from "./MyAccountScreen.vue?vue&type=script&lang=js&"
import style0 from "./MyAccountScreen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDialog,VSnackbar,VTextField})
